var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalLoanIdCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.596,
    height: 23.677,
    viewBox: "0 0 29.596 23.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1213b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6192e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "id_card_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24",
    d: "M103.677-786.682a1.432,1.432,0,0,0,1.054-.425,1.432,1.432,0,0,0,.425-1.054,1.432,1.432,0,0,0-.425-1.054,1.432,1.432,0,0,0-1.054-.425H99.237a1.432,1.432,0,0,0-1.054.425,1.432,1.432,0,0,0-.425,1.054,1.432,1.432,0,0,0,.425,1.054,1.432,1.432,0,0,0,1.054.425Zm0-4.439a1.432,1.432,0,0,0,1.054-.425,1.432,1.432,0,0,0,.425-1.054,1.432,1.432,0,0,0-.425-1.054,1.432,1.432,0,0,0-1.054-.425H99.237a1.432,1.432,0,0,0-1.054.425,1.432,1.432,0,0,0-.425,1.054,1.432,1.432,0,0,0,.425,1.054,1.432,1.432,0,0,0,1.054.425Zm-13.318,4.439a11.023,11.023,0,0,0-2.4.24,5.878,5.878,0,0,0-1.887.758,3.779,3.779,0,0,0-1.184,1.091,2.323,2.323,0,0,0-.407,1.313.949.949,0,0,0,.333.74,1.181,1.181,0,0,0,.814.3h9.471a1.141,1.141,0,0,0,.814-.314,1.047,1.047,0,0,0,.333-.8,2.129,2.129,0,0,0-.407-1.221,4.309,4.309,0,0,0-1.184-1.11,5.878,5.878,0,0,0-1.887-.758A11.023,11.023,0,0,0,90.358-786.682Zm2.09-2.349a2.85,2.85,0,0,0,.869-2.09,2.85,2.85,0,0,0-.869-2.09,2.85,2.85,0,0,0-2.09-.869,2.85,2.85,0,0,0-2.09.869,2.85,2.85,0,0,0-.869,2.09,2.85,2.85,0,0,0,.869,2.09,2.85,2.85,0,0,0,2.09.869A2.85,2.85,0,0,0,92.449-789.031ZM82.96-776.323a2.85,2.85,0,0,1-2.09-.869,2.85,2.85,0,0,1-.869-2.09V-797.04a2.85,2.85,0,0,1,.869-2.09A2.85,2.85,0,0,1,82.96-800h23.677a2.85,2.85,0,0,1,2.09.869,2.85,2.85,0,0,1,.869,2.09v17.757a2.85,2.85,0,0,1-.869,2.09,2.85,2.85,0,0,1-2.09.869Z",
    transform: "translate(-80 800)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalLoanIdCard);
export default __webpack_public_path__ + "static/media/digital-loan-id-card.75dd6945b76c43a8802abecab69b199d.svg";
export { ForwardRef as ReactComponent };